module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAWCAYAAAAvg9c4AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAN1JREFUeNqkVAsNAyEMJWdgSDgJ52CTMAlIOAnnYBKQsEwBc4AE5gAJjMtYwm4tbeElzSW0vB79PKUaSCnN2bZsPv0iZLO7X0lQyDi4ZdMcQptk8E3ikrkHrlVDDHG/WL4YjOTZ6yHOIOQBIo2s7J/YBfmBhQryHQ01UxUDde9BDArknyfi0onwg2NUk74A/5UgPQNnz2ONAlCjDamnQRqluat5/3a10gMIFsquieGmcBkVkr/XUILihYSRlMHGtvB3XthdujmDuupUDxrEnqX4AmI3RFgRr9wavgUYAIPsfVhzOUlsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// C:/NightKey/CMS/nightkey-cms/src/assets/img/location.png
// module id = ../../../../../src/assets/img/location.png
// module chunks = main